import { Outlet } from "react-router-dom";

import { Box } from "@mui/material";
import AppBarComponent from "../../shared/components/home-navbar/home-navbar";

import "./home-page-style.scss";

const HomePage = () => {
    return (
        <Box sx={{ height: '100dvh', minHeight: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <AppBarComponent />
            <Box sx={{ height: { xs: "60px", sm: "68px" }, minHeight: { xs: "60px", sm: "68px" } }}></Box>
            <Box
                sx={{
                    height: { xs: 'calc(100dvh - 60px)', sm: 'calc(100dvh - 68px)' },
                    maxHeight: { xs: 'calc(100dvh - 60px)', sm: 'calc(100dvh - 68px)' },
                    overflow: 'auto',
                    pb: "env(safe-area-inset-bottom)",
                }}
            >
                {/* <SideBarComponent> */}
                <Outlet />
                {/* </SideBarComponent> */}
            </Box >
        </Box>
    )
};

export default HomePage;
